<template>
	<a ref="link" :href="project" @click="linkClickHandler">
		<div ref="container" class="container">
			<div ref="input" :contenteditable="editing" @input="nameInputHandler">{{editableName}}</div>
			<div class="button-group-1" v-if="!editing">
				<button class="btn-action" @click="editProjectNameClickHandler">
					<i class="fa fa-pen"></i>
				</button>
			</div>
			<div class="button-group-2" v-if="editing">
				<button class="btn-action" @click="cancelProjectNameClickHandler">
					<i class="fa fa-times"></i>
				</button>
				<button class="btn-action" @click="saveProjectNameClickHandler">
					<i class="fa fa-save"></i>
				</button>
			</div>
		</div>
	</a>
</template>

<script>

import xhrModule from '../modules/xhrModule.js'

export default {
	name: 'ProjectSwitchItem',
	props: {
		project: String,
		name: String
	},

	data () {
		return {
			editing: false,
			editableName: this.name
		}
	},

	watch: {
		name (newValue) {
			this.editableName = newValue
		}
	},

	methods: {
		nameInputHandler (e) {
			// const value = e.target.textContent
		},

		editProjectNameClickHandler (e) {
			e.preventDefault()

			this.editing = true
			this.$refs.input.setAttribute('contenteditable', true)
			this.$refs.input.focus()

			this.$refs.container.classList.add('active')
		},

		cancelProjectNameClickHandler (e) {
			e.preventDefault()
			this.editing = false
			// reset name to original
			this.$refs.input.textContent = this.name
		},

		saveProjectNameClickHandler (e) {
			e.preventDefault()

			const newName = this.$refs.input.textContent
			let projectUrl = this.$refs.link.getAttribute('href')

			const source = projectUrl.split('/cms')[0]
			const data = {
				source: source,
				name: newName
			}

			const json = JSON.stringify(data)
			var url = '/cms/api/master/updateProjectName'
			xhrModule.post(url, json, this.saveProjectNameComplete.bind(this))
		},

		saveProjectNameComplete (data) {
			this.editing = false
		},

		linkClickHandler (e) {
			if (this.editing) e.preventDefault()
		}
	}
}
</script>
